export default __webpack_public_path__ + "static/media/nine.e893cdf3.jpeg";